export default "/images/tick-green.svg?d80d052a71cfc919ebf7de797d2d183e";